import { ClientDefectStatus } from './printRequestDefect.models';
import { PRStatus } from "./print.request.models";

export interface IOrder {
  id: number;
  orderDate: string | Date;
  plannedShipDate: string;
  orderStatus: number;
  cancellable: boolean;
  billingInfo: {
    firstName: string;
    lastName: string;
    company: string;
    countryId: number;
    countryName: string;
    stateProvinceId: number;
    stateProvinceName: string;
    city: string;
    address1: string;
    phoneNumber: string;
    zipPostalCode: string;
  };
  shippingInfo: {
    firstName: string;
    lastName: string;
    company: string;
    countryId: number;
    countryName: string;
    stateProvinceId: number;
    stateProvinceName: string;
    city: string;
    address1: string;
    phoneNumber: string;
    zipPostalCode: string;
  };
  printRequests: IPrintRequests[];
  progression: number;
}

export interface IPrintRequests {
  printRequestId: number;
  progress: number;
  length: number;
  size: string;
  fabricCode: string;
  lastPrintDate: string | Date | null;
  status: PRStatus;
  productImage: string;
  sku: string;
  dueDate: string | Date;
  version: number;
  defectStatus?: ClientDefectStatus;
  productName?: string;
  bundlePrIds?: number[];
  shippingWindowLabel?: string;
}

export interface IOrderStatus {
  title: string;
  status: OrderStatusType;
  prStatus: PRStatus[];
  icon: React.FunctionComponent<
    React.SVGProps<SVGSVGElement> & {
      title?: string | undefined;
    }
  >;
}

export enum OrderStatusType {
  InPreparation = "InPreparation",
  InProduction = "InProduction",
  ReadyToShip = "ReadyToShip",
  Shipped = "Shipped",
  Canceled = "Canceled"
}